import styled, { css } from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import AddButton from 'Containers/Validations/components/AddButton';
import { boxShadow, flexCenter, flexSpaceCenter, pxToRem } from 'Styles/utils/utils';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';

export const TrushArea = styled.div`
  border-radius: 14px;
  margin-left: ${pxToRem(20)};
  height: 90%;
  ${flexCenter} svg {
    cursor: pointer;
    path {
      stroke: ${({ theme: { colors } }) => colors.red_1};
    }
  }

  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    margin-left: ${pxToRem(28)};
  }
`;
export const Container = styled(FlexContainer)``;

export const CardContainer = styled.div`
  width: 90%;
  background: ${({ theme: { colors } }) => colors.white};
  ${boxShadow}
  border-radius: 14px;
  border: 1px solid transparent;
  position: relative;
  transition: 0.3s ease-out;
  padding: ${pxToRem(30)};
  margin-bottom: ${pxToRem(20)};
  ${({ isSelected, theme: { colors } }) =>
    isSelected &&
    css`
      background-color: ${colors.green_6};
      border: 1px solid ${colors.green_3};
      cursor: pointer;
    `}

  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    width: 85%;
    padding: ${pxToRem(24)};
  }
`;

export const Header = styled.div`
  ${flexSpaceCenter}
  padding-bottom: ${pxToRem(10)};
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  @media screen and (max-width: ${({ theme: { mediaQueries } }) => mediaQueries.mobile_width}) {
    p {
      max-width: 100%;
    }
  }
`;

export const SelectedStatus = styled.div`
  display: flex;
  cursor: pointer;
  @media screen and (max-width: ${({ theme: { mediaQueries } }) => mediaQueries.mobile_width}) {
    > div:first-child {
      margin-right: 0;
    }
    p {
      display: none;
    }
  }
`;

export const AddButtonStyled = styled(AddButton)`
  margin-bottom: 0;
  line-height: 1rem;
  color: ${({ theme: { colors } }) => colors.green_3};
  svg {
    width: 20px;
    height: 20px;
    circle {
      fill: ${({ theme: { colors } }) => colors.green_3};
    }
  }

  @media screen and (max-width: ${({ theme: { mediaQueries } }) => mediaQueries.mobile_width}) {
    svg {
      margin-right: 0;
    }
    span {
      display: none;
    }
  }
`;

export const Body = styled.div`
  display: flex;
  padding-top: ${pxToRem(14)};
`;
